<template>
<div class="container" v-if="type" @click.stop="closeGuide">
  <div class="library-guide-container" v-if="type === 'library'">
    <img class="library-img" src="https://files.wondercv.com/PC/cveditor/jingliku.png" alt="经历库在这里哦~">
    <div class="library-icon-container flex">
      <div class="library-icon">
        <img src="https://files.wondercv.com/PC/editor/jingliku.png" alt="">
      </div>
      <div class="library-text">经历库</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "NewAccountGuide",
  props: {
    type: {
      type: String,
      default: "",
    }
  },
  methods: {
    closeGuide() {
      this.$emit('closeGuide');
    }
  }
}
</script>

<style lang="scss" scoped>
@keyframes libraryAnimation {
  0% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(5px);
  }
}
.container {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, .6);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  .library-guide-container {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    .library-img {
      width: 250px;
      height: 302px;
      object-fit: contain;
      position: absolute;
      bottom: 55px;
      right: 94px;
      animation: libraryAnimation 2s infinite linear;
    }
    .library-icon-container {
      width: 66px;
      height: 84px;
      padding: 10px 0;
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #353944;
      //background-color: rgba(53, 57, 68, .3);
      position: absolute;
      bottom: 127px;
      right: 17px;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .library-text {
        width: 100%;
        text-align: center;
        font-size: 12px;
        color: #fff;
      }
      .library-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        z-index: 1;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
